import { FormattedMessage } from 'react-intl';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { Button, Form } from 'react-bootstrap';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { doLoginWithEmail, setEmailUser, setPasswordUser } from '../../actions/auth';
import { openModal } from '../../actions/modal';
import { FORGOT_PASSWORD_MODAL_NAME } from '../../../sell/constants/modal';
import ForgotPasswordModal from '../../../sell/components/modals/ForgotPasswordModal';

const LoginContentStep2 = ({ auth, goToNextStep }) => {
    const dispatch = useDispatch();

    const loginWithEmail = (e) => {
        e.preventDefault();
        dispatch(doLoginWithEmail(auth.email, auth.password, goToNextStep));
    };

    const forgotPasswordClick = (e) => {
        e.stopPropagation();
        dispatch(openModal(FORGOT_PASSWORD_MODAL_NAME));
    };

    return (
        <>
            <Form onSubmit={loginWithEmail}>
                <FloatingLabel controlId='login-email' label={<FormattedMessage id='login_modal_email_placeholder'/>} className="mb-3">
                    <Form.Control size="lg" label={<FormattedMessage id='login_modal_email_placeholder'/>}
                        type="email"
                        value={auth.email}
                        required="required"
                        onChange={(e) => dispatch(setEmailUser(e.target.value))}
                        placeholder={<FormattedMessage id='login_modal_email_placeholder'/>}/>
                </FloatingLabel>
                <FloatingLabel controlId='login-password' label={<FormattedMessage id='login_modal_password'/>} className="mb-3">
                    <Form.Control size="lg" label={<FormattedMessage id='login_modal_password'/>}
                        type="password"
                        value={auth.password}
                        required="required"
                        onChange={(e) => dispatch(setPasswordUser(e.target.value))}
                        placeholder={<FormattedMessage id='login_modal_password'/>}/>
                </FloatingLabel>
                <div className="mt-3 d-flex justify-content-between">
                    <Form.Check type="checkbox" label={<FormattedMessage id='login_modal_remember'/>} size='lg' />
                    <span className='link-primary ms-2 '>
                        <Link onClick={forgotPasswordClick} className="text-decoration-none"><FormattedMessage id='login_modal_forgot_password'/></Link>
                    </span>
                </div>
                <div className="d-grid mt-4 mb-4">
                    <Button variant="primary" type="submit">
                        <FormattedMessage id='login_modal_email_contiune'/>
                    </Button>
                </div>
                {auth.error && <p className="text-danger mt-3">{auth.error}</p>}
            </Form>
            <ForgotPasswordModal open={false} />
        </>
    );
};
export default LoginContentStep2;
